let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9bqGG")).then(() => parcelRequire('7bAIN'));